import {
  getTopPlayers as getTopPlayersCall,
  getTopTeams as getTopTeamsCall,
  getTopUsersByNumber as getTopUsersByNumberCall,
} from "./api/topService";
import NotificationService from "../components/Notification/notificationService";
import LoginService from "./loginService";
import {
  Image,
  PlayerWithCount,
  TeamWithCount,
  TopResponse,
} from "./shirts/types";
import { TopUser, UserDataUpdate } from "../types/authTypes";

export default function TopService() {
  const { error: errorNotification } = NotificationService();
  const { setLogout } = LoginService();

  const handleError = (status: number, description: string) => {
    if (status === 401) {
      setLogout();
    } else {
      errorNotification(description);
    }
  };

  const getTopPlayers = async (limit: number, page: number) => {
    let response = await getTopPlayersCall(limit, page).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      const data: Array<PlayerWithCount> = response.data.data;
      const total: number = response.data.meta.total;
      const lastPage: number = response.data.meta.last_page;

      const processedResponse: TopResponse = {
        data: data,
        total: total,
        lastPage: lastPage,
      };

      return processedResponse;
    } else {
      return undefined;
    }
  };
  const getTopTeams = async (limit: number, page: number) => {
    let response = await getTopTeamsCall(limit, page).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      const data: Array<TeamWithCount> = response.data.data;
      const total: number = response.data.meta.total;
      const lastPage: number = response.data.meta.last_page;

      const processedResponse: TopResponse = {
        data: data,
        total: total,
        lastPage: lastPage,
      };

      return processedResponse;
    } else {
      return undefined;
    }
  };
  const getTopUsersByNumber = async (
    limit: number,
    page: number,
    startDate?: string | undefined,
    endDate?: string | undefined,
  ) => {
    let response = await getTopUsersByNumberCall(
      limit,
      page,
      startDate,
      endDate,
    ).catch(function (error) {
      const status = error.response.status;
      const description = error.response.data.error_description;
      handleError(status, description);
    });

    if (response?.data) {
      const data: Array<TopUser> = response.data.data;
      const total: number = response.data.meta.total;
      const lastPage: number = response.data.meta.last_page;

      const processedResponse: TopResponse = {
        data: data,
        total: total,
        lastPage: lastPage,
      };

      return processedResponse;
    } else {
      return undefined;
    }
  };

  return {
    getTopPlayers,
    getTopTeams,
    getTopUsersByNumber,
  };
}
